import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { COUNTRIES } from '../constants';
import { Base } from '../models';

export function reorderCountries(
  countryPlateCode: string,
  translatedCountries: Base[],
  hasDefaultCountryOfOrigin$?: BehaviorSubject<boolean>,
): Base[] {
  const defaultCountry: Base | undefined = translatedCountries.find((country: Base) => country.id === countryPlateCode);

  if (hasDefaultCountryOfOrigin$) {
    hasDefaultCountryOfOrigin$.next(!!defaultCountry);
  }

  return defaultCountry
    ? [defaultCountry, ...translatedCountries.filter((country: Base) => country.id !== countryPlateCode)]
    : translatedCountries;
}

export function translateCountries(translateService: TranslateService): Base[] {
  return COUNTRIES.map((country: Base) => {
    return {
      id: country.id,
      name: translateService.instant(`common.countries.${country.id}`) + ' ' + `(${country.id})`,
    };
  });
}
